import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();
export const eventsServiceApi = createApi({
  reducerPath: 'eventsServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetEvents: builder.query<any, any>({
      query: ({ page, perPage, language = CURRENT_LANGUAGE }) =>
        `event/?pageNumber=${page}&elementsPerPage=${perPage}&locale=${language}`,
    }),
    GetEventCategories: builder.query<any, any>({
      query: ({language = CURRENT_LANGUAGE}) => 'event/category?locale=' + language,
    }),
    GetEventById: builder.query<any, any>({
      query: ({ id, language = CURRENT_LANGUAGE }) => `event/${id}?locale=${language}`,
    }),
    GetEventsByCategoryId: builder.query<any, any>({
      query: ({ categoryId, language = CURRENT_LANGUAGE, pageNumber, elementsPerPage }) => `event/?${categoryId && `categoryId=${categoryId}&`}locale=${language}&pageNumber=${pageNumber}&elementsPerPage=${elementsPerPage}`,
    }),
  }),
});

export const { useLazyGetEventsQuery, useLazyGetEventCategoriesQuery, useLazyGetEventByIdQuery, useLazyGetEventsByCategoryIdQuery } =
  eventsServiceApi;
